import ProductResourceView from '@/mixins/ProductResourceView';
import { mapState } from 'vuex';

export default {
  mixins: [ProductResourceView],
  data() {
    return { isAppendingPage: false };
  },
  computed: {
    ...mapState('product', ['pagy']),
    paginationProps() {
      return {
        pagy: this.pagy,
        disabled: this.isAppendingPage
      };
    },
    paginationEvents() {
      return {
        click: this.clickPage,
        append: this.appendPage
      };
    }
  },
  methods: {
    clickPage(page) {
      this.searchResource({ page });
    },
    appendPage({ page, offset }) {
      this.isAppendingPage = true;
      this.fetchProducts({
        params: { ...this.defaultResourceParams, ...this.resourceParams, page },
        append: true
      }).finally(() => {
        this.isAppendingPage = false;
        if (offset) this.windowService.scrollTo(offset);
      });
    }
  }
};
